export const TreatmentClassificationTypes = Object.freeze({
  ADDON: 'ADDON',
  REMOVAL_1: 'REMOVAL_1',
  REMOVAL_2: 'REMOVAL_2',
});

export const TreatmentBookingOptionTypes = Object.freeze({
  BOOKABLE: 'BOOKABLE',
  CLARINS: 'CLARINS',
});
